<template>
    <div class="view--presales">
        <div class="page-header">
            <PageTitle title="Presales" icon="pe-7s-hourglass" />
        </div>

        <div class="page-body">
            <template v-if="navTabsVisible">
                <b-row>
                    <b-col>
                        <TabCollection :tabs="navTabs" />
                    </b-col>
                </b-row>
            </template>
            
            <router-view />
        </div>
    </div>
</template>

<script>
import PageTitle from '@/components/PageTitle.vue';
import TabCollection from '@/components/TabCollection';
import {hasPermission} from "@/helpers/permissions";

export default {
    name: 'Presales',

    components: {
        PageTitle,
        TabCollection
    },

    data() {
      return {
        presales: [],
      }
    },

    computed: {
        navTabs() {
            let tabs = [
                {
                    routeName: 'PresaleListIncomplete',
                    matchRouteNames: 'PresaleListIncomplete',
                    name: 'Onvolledige presales',
                },
                {
                    routeName: 'PresaleListActive',
                    matchRouteNames: 'PresaleListActive',
                    name: 'Lopende presales',
                },
                {
                    routeName: 'PresaleListFuture',
                    matchRouteNames: 'PresaleListFuture',
                    name: 'Toekomstige presales',
                },
                {
                    routeName: 'PresaleListHistory',
                    matchRouteNames: 'PresaleListHistory',
                    name: 'Afgelopen presales',
                },
            ]

            if (this.hasPermission('presales.batchcreatestorelabels')) {
                tabs = tabs.concat([
                    {
                        routeName: 'PresaleStoreLabels',
                        matchRouteNames: 'PresaleStoreLabels',
                        name: 'Winkel labels',
                    },
                ])
            }

            return tabs
        },

        navTabsVisible() {
            return this.navTabs.map(tab => tab.matchRouteNames).indexOf(this.$route.name) > -1;
        },
    },
}
</script>